<template>
  <div class="famousTeaSpecialarea">
    <InteractiveTeaApp v-if="link==='interactiveTeaApp'" :props-id="link" />
    <FamousTeaSpecialarea v-if="link==='famousTeaSpecialarea'" :props-id="link" />
  </div>
</template>
<script>
import InteractiveTeaApp from './moduleDetail/interactiveTeaApp/index';
import FamousTeaSpecialarea from './moduleDetail/famousTeaSpecialarea/index';
export default {
  name: 'Module',
  components: {
    FamousTeaSpecialarea,
    InteractiveTeaApp
  },
  data: () => {
    return {
      link: ''
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.link = route.params.id;
      },
      immediate: true
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
</style>

